import { createConfirmation } from "react-confirm";
import AddTeamMemberDialog from "./AddTeamMemberDialog";

export const showAddTeamMemberDialog = createConfirmation(AddTeamMemberDialog);
